import Cookies from "js-cookie";

export function storeIntegrationInCookies(data, integration_type){
    let array = getIntegrationsFromCookies();
    data = {...data, type: integration_type};
    var index = array.findIndex(x => x.type == integration_type);
    if(index != -1){
        array[index] = data;
    }else{
        array.push(data);
    }
    let obj_decoded = JSON.stringify(array);
    return Cookies.set('integrations', obj_decoded, { expires: 2 });
}

export function getIntegrationsFromCookies(){
    let string = (Cookies.get('integrations'))? Cookies.get('integrations') : '[]';
    return JSON.parse(string);
}

export function deleteIntegrationsFromCookiesByType(type){
    let arr = getIntegrationsFromCookies().filter(x => x.type != type);
    return Cookies.set('integrations', JSON.stringify(arr), { expires: 2 });
}

export function setProductIntegrationInCookie(productId){
    var inTwoMinutes = new Date(new Date().getTime() + 2 * 60 * 1000);
    return Cookies.set('is_integrating_' + productId, true, { expires: inTwoMinutes });
}

export function getProductIntegrationInCookie(productId){
    return !!(Cookies.get('is_integrating_' + productId));
}

